<template>
  <div class="background">
    <!-- 背景 -->
    <img class="top-hor-line" src="../../assets/images/1025/top-hor-line.png" />
    <img class="left-top-corner" src="../../assets/images/1025/left-top-corner.png" />
    <img class="right-top-corner" src="../../assets/images/1025/right-top-corner.png" />
    <img class="left-bottom-corner" src="../../assets/images/1025/left-bottom-corner.png" />
    <img class="right-bottom-corner" src="../../assets/images/1025/right-bottom-corner.png" />
    <img class="left-border-line" src="../../assets/images/1025/left-border-line.png" />
    <img class="right-border-line" src="../../assets/images/1025/right-border-line.png" />
    <!-- 标题 -->
    <p class="banner-title">{{ $t('Monitoring1025.banner') }}</p>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  methods: {},
  created() {},
  async mounted() {},
  destroyed() {},
}
</script>

<style lang="scss" scoped>
.background {
  width: 100%;
  height: 100%;
  position: absolute;

  .top-hor-line {
    position: absolute;
  }

  .left-top-corner {
    position: absolute;
    left: 20px;
    top: 35px;
  }

  .left-bottom-corner {
    position: absolute;
    left: 20px;
    bottom: 35px;
  }

  .right-top-corner {
    position: absolute;
    right: 20px;
    top: 35px;
  }

  .right-bottom-corner {
    position: absolute;
    right: 20px;
    bottom: 35px;
  }

  .left-border-line {
    position: absolute;
    left: 20px;
    top: 278px;
  }

  .right-border-line {
    position: absolute;
    right: 20px;
    top: 278px;
  }

  .banner-title {
    position: absolute;
    top: 25px;
    height: 48px;
    text-align: center;
    font-weight: normal;
    font-size: 30px;
    color: #ffffff;
    width: 100%;
    background: radial-gradient(0deg, #d7d7d7 0%, #ffffff 100%);
    font-family: Swiss721BT, Swiss721BT;
    font-style: normal;
    text-transform: none;
  }
}
</style>
